import InlineChromiumBugfix from "@/components/InlineChromiumBugFix";
import { RenderTypedElementProps } from "../TypedElement";
import ConceptObservationInput from "@/components/inputs/ObservationInput/ConceptObservationInput";
import useSlateInputElement from "@/editor/utils/useSlateInputElement";
import { SettingsPanelPortal } from "@/components/layout/SettingsPanel";
import { Transition } from "@headlessui/react";
import PropertiesForm from "./ConceptPropertiesForm";
import { IConceptObservationInputElement } from "./types";

type RenderDropdownInputElementProps = RenderTypedElementProps & {
  element: IConceptObservationInputElement;
};

const RenderDropdownInputElement = (props: RenderDropdownInputElementProps) => {
  const { element, attributes, children } = props;
  const { name, update, disabled, showProperties, active } =
    useSlateInputElement(element);
  const { children: _, name: __, inputType, type, ...other } = element;
  return (
    <span {...attributes} tabIndex={-1}>
      <InlineChromiumBugfix />
      <ConceptObservationInput
        name={name}
        disabled={disabled}
        active={active}
        {...other}
      />
      {children}
      <InlineChromiumBugfix />
      <SettingsPanelPortal>
        <Transition show={showProperties} enter="ease-in-out duration-75">
          <PropertiesForm onSubmit={update} defaultValues={element} />
        </Transition>
      </SettingsPanelPortal>
    </span>
  );
};

export default RenderDropdownInputElement;
